<ul class="nav navbar-nav side-menu" id="sidebarnav" [class.is-collapsed]="collapsed">
  <li class="menu-dashboard" routerLinkActive="Active" [routerLinkActiveOptions]="{ exact: true }">
    <a routerLink="/Dashboard" aria-label="داشبورد"
      [tooltip]="'داشبورد'" [isDisabled]="!collapsed" placement="left" container="body">
      <span class="menu-icon"><i class="ti-home" aria-hidden="true"></i></span>
      <span class="right-nav-text">داشبورد</span>
    </a>
  </li>

  <ng-container *ngFor="let menuLvl1 of Data_Menu">
    <li class="menu-title" [class.menu-group-active]="isGroupActive(menuLvl1)"
      [class.menu-group-open]="menuLvl1.visible && !collapsed">
      <button type="button" class="menu-title-button" (click)="toggleMenu(menuLvl1)"
        [attr.aria-label]="menuLvl1.title"
        [tooltip]="menuLvl1.title.toString()" [isDisabled]="!collapsed" placement="left" container="body"
        [attr.aria-expanded]="collapsed ? false : menuLvl1.visible">
        <span class="menu-icon"><i [class]="getMenuIcon(menuLvl1)" aria-hidden="true"></i></span>
        <span class="menu-title-text">{{menuLvl1.title}}</span>
        <span *ngIf="menuLvl1.count>0" class="menu-count" aria-label="اعلان جدید"></span>
        <i class="fa fa-angle-down menu-chevron" aria-hidden="true"></i>
      </button>
    </li>

    <li class="submenu-item" [hidden]="collapsed || !menuLvl1.visible"
      *ngFor="let menuLvl2 of menuLvl1.child" routerLinkActive="Active">
      <a *ngIf="menuLvl2.parent>0" [routerLink]="menuLvl2.link"
        (click)="Set_Count_Zero(menuLvl2)">
        <span class="menu-icon"><i [class]="menuLvl2.icon || 'fa fa-circle-o'" aria-hidden="true"></i></span>
        <span class="right-nav-text">{{menuLvl2.title}}</span>
        <span *ngIf="menuLvl2.count>0" class="badge badge-pill badge-danger">{{menuLvl2.count}}</span>
        <span *ngIf="menuLvl2.new>0" class="badge badge-pill badge-info">جدید {{menuLvl2.new}}</span>
      </a>
    </li>
  </ng-container>
</ul>
